var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-white border-0"
    },
    [
      _c("div", { staticClass: "rounded-t bg-blue-500 mb-0 px-6 py-6" }, [
        _c(
          "div",
          { staticClass: "text-center flex justify-between items-center" },
          [
            _c("div", { staticClass: "flex flex-col items-start" }, [
              _c("h6", { staticClass: "text-white text-xl font-bold" }, [
                _vm._v(_vm._s(_vm.title))
              ]),
              _vm._v(" "),
              _vm.subtitle !== ""
                ? _c("p", { staticClass: "mt-2 text-xs text-white" }, [
                    _vm._v(_vm._s(_vm.subtitle))
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex flex-col md:flex-row" },
              [_vm._t("button")],
              2
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "flex-auto px-4 lg:px-10 py-10" },
        [_vm._t("body")],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7b886a75", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b886a75","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Layout/Card.vue
// module id = null
// module chunks = 